import "./App.css";
import { Pannellum } from "pannellum-react";
import pano1 from "./assets/1.360.jpg";
import pano2 from "./assets/2.360.jpg";
import pano3 from "./assets/3.360.jpg";
import pano4 from "./assets/4.360.jpg";

import React, { useEffect, useState } from "react";

const hotspots = [
  {
    pano: pano1,
    pitch: 0,
    yaw: -60,
    map: {
      1: {
        id: 1,
        pitch: 10,
        yaw: 30,
      },
      2: {
        id: 2,
        pitch: 22,
        yaw: 5,
      },
      3: {
        id: 3,
        pitch: 10, // y
        yaw: -35, // x
      },
    },
  },
  {
    pano: pano2,
    pitch: 10,
    yaw: 30,
    map: {
      0: {
        id: 0,
        pitch: -5,
        yaw: -60,
      },
      2: {
        id: 2,
        pitch: 10,
        yaw: 55,
      },
      3: {
        id: 3,
        pitch: 15, // y
        yaw: -5, // x
      },
    },
  },
  {
    pano: pano3,
    pitch: 22,
    yaw: 5,
    map: {
      0: {
        id: 0,
        pitch: 18,
        yaw: -10,
      },
      1: {
        id: 1,
        pitch: 10,
        yaw: -35,
      },
      3: {
        id: 3,
        pitch: 10, // y
        yaw: 30, // x
      },
    },
  },
  {
    pano: pano4,
    pitch: 10, // y
    yaw: -35, // x
    map: {
      0: {
        id: 0,
        pitch: 0,
        yaw: 45,
      },
      1: {
        id: 1,
        pitch: 15,
        yaw: 5,
      },
      2: {
        id: 2,
        pitch: 0,
        yaw: -60,
      },
    },
  },
];

function preloadImages(images) {
  for (let i = 0; i < images.length; i++) {
    let l = document.createElement("link");
    l.rel = "preload";
    l.as = "image";
    l.href = images[i];
    document.head.appendChild(l);
  }
}

function App() {
  useEffect(() => {
    preloadImages(hotspots.map((h) => h.pano));
  }, []);
  const [hotspot, setHotspot] = useState(0);
  const [visible, setVisible] = useState(false);
  return (
    <>
      {!visible ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <div className="lds-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
      ) : null}
      <div style={{ opacity: visible ? 1 : 0, width: "100%", height: "100%" }}>
        {/* <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "50px",
          width: "50px",
          background: "red",
          zIndex: 1000,
        }}
      >
        {hotspot}
      </div> */}
        <Pannellum
          width="100%"
          height="100%"
          showZoomCtrl={false}
          showFullscreenCtrl={false}
          image={hotspots[hotspot].pano}
          pitch={0}
          yaw={0}
          hfov={100}
          maxHfov={120}
          minHfov={80}
          onLoad={() => setVisible(true)}
          autoLoad
        >
          {hotspots.map((h, i) =>
            i !== hotspot ? (
              <Pannellum.Hotspot
                key={i}
                type="custom"
                pitch={hotspots[hotspot].map[i].pitch}
                yaw={hotspots[hotspot].map[i].yaw}
                handleClick={(evt, args) => {
                  setVisible(false);
                  setHotspot(i);
                }}
              />
            ) : (
              <React.Fragment key={i}></React.Fragment>
            )
          )}
        </Pannellum>
      </div>
    </>
  );
}

export default App;
